import { createPinia } from 'pinia'
import { createApp, toValue } from 'vue'
import { setGtmContext } from './Integrations/gtm'
import { initSentryForEnrollment } from './Integrations/sentry'
import { useContactStore } from './Stores/contact'
import { useDeviceSettingsStore } from './Stores/deviceSettings'
import Submission from './Submission.vue'
import { setLocale } from './http'
import { i18n } from './i18n'
import { PostmessageExternalReceiver, PostmessageExternalSender } from './postmessage-api-external'
import router from './router'

const app = createApp(Submission)

initSentryForEnrollment(app, router)

setLocale(toValue(i18n.global.locale.value))

app.use(i18n)
app.use(createPinia())
app.use(router)
setGtmContext(app, router)
app.mount('#submission')

const postMessageExternalReceiver = new PostmessageExternalReceiver(
    import.meta.env.VITE_ALLOWED_POST_MESSAGE_ORIGIN
        ? [import.meta.env.VITE_ALLOWED_POST_MESSAGE_ORIGIN]
        : []
)

postMessageExternalReceiver.addPublicEventListener((api: string, data: any) => {
    if (api === 'navigateTo' && data.type === 'back') {
        const { currentRoute } = router

        if (['home', 'success'].includes(currentRoute.value.name as string)) {
            if (currentRoute.value.name === 'home' && currentRoute.value.query.entryToken) {
                router.back()

                return
            }

            new PostmessageExternalSender().close()

            return
        }

        router.back()

        return
    }

    if (api === 'navigateTo' && data.type === 'contact-impact') {
        const contactStore = useContactStore()
        return contactStore.open()
    }
})

postMessageExternalReceiver.addPublicEventResponseListener((api: string, response: any) => {
    if (api === 'getDeviceSettingsStatus' && response.pushMessageSettings.code === 'OK') {
        const deviceSettingsStore = useDeviceSettingsStore()
        deviceSettingsStore.pushNotificationsEnabled = response.pushMessageSettings.isEnabled
        return
    }
})
